module.exports = __webpack_public_path__ + "img/Warlock-gnome-f-70.0d556592.gif";